<template>
    <div class="application-filed-container">
        <img
            class="base-banner"
            v-src="'https://oss.cloud.custouch.com/res/11276/应用领域@3x.png'"
        />
        <div class="panel-wrapper">
            <h4>{{ title }}</h4>
            <div class="panel-content">
                <router-link
                    class="panel"
                    v-for="field in applicationDic"
                    :key="field.id"
                    :to="{
                        name: 'applicationFieldList',
                        params: { hId: field.id }
                    }"
                    ><img class="bc" :src="field.detail.img" />
                    <div class="row">
                        <span>{{ field.name }}</span
                        ><img class="arrow" src="@/assets/imgs/arrow-b.png" />
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import { getDataHierarchies } from '@custouch/proxy-use'
export default {
    props: ['title', 'mId'],
    data() {
        return {
            applicationDic: {}
        }
    },
    async created() {
        this.applicationDic  = await getDataHierarchies(this.mId)
        this.$nextTick(() => {
            anime({
                targets: '.bc',
                opacity: [0, 1],
                borderRadius: ['50%', 0],
                duration: 750,
                easing: 'easeOutSine',
                delay: anime.stagger(100)
            })
        })
    }
}
</script>

<style scoped lang="less">
.panel-wrapper {
    padding: 1rem;
}
.panel-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.panel {
    width: 8rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.2rem;
    .bc {
        object-fit: contain;
        height: 5.2rem;
    }
    .row {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        height: 2.7rem;
        padding: 0.4rem;
        background: #f0f0f0;
    }
    .arrow {
        width: 0.6rem;
        object-fit: contain;
        margin-top: 0.2rem;
    }
}
</style>
